<template>
  <div class="txt">
    <div class="text-right">
    <b-button id="button" @click="showModal" ref="btnShow" class="btn btn-warning btn-lg">Ver las barreras de esta sección</b-button>
    </div>
    <!-- <b-img right src="../assets/img/iconoNA.png" v-on:click="showModal" /> -->

    <b-modal ref="my-modal" size="lg" >
        <div class="w-100 p-1 text-light bg-dark tituloModal"> 
          Barreras
        </div>
      <b-tabs content-class="mt-3" pills active-nav-item-class="tab">
        <b-tab v-for="bar in barreras" :key="bar.titulo_barrera" :title = "bar.titulo_barrera" @click ="selectBarrier(bar)"></b-tab> <!-- title-link-class="tab"-->
      </b-tabs>
        <div class="w-100 p-1 text-light bg-secondary tituloModal"> 
          Personas con discapacidad
        </div>


        <!-- ****************************************************************** -->
        <!-- ****************************************************************** -->
        <!-- ****************************************************************** -->
      
     

      <b-tabs  content-class="mt-3" card fill active-nav-item-class="font-weight-bold text-uppercase text-dark">
        
          <b-tab title="Cesar Cerezo" >
                <template #title>
                  <span class="icoVisual">Cesar Cerezo</span>
                </template>
          <div class="txt">
            <span v-if="barrera.visual.visual_comentario!='A mí no me afecta esta barrera'">
            <b-container fluid>
            <b-row>
              <div class="w-100 p-1 text-light colorRojoSuave textoGrande"> 
                  <img src="../assets/img/iconoAlerta.png" height="30" width="30"/> 
                  {{barrera.visual.visual_subtitulo}}
              </div>
            </b-row>
              <div class="w-100 p-1 text-dark bg-ligth"></div> 
              <b-row>
            <!-- <b-row class="mx-auto overflow-auto h-25"> -->
              <b-col cols="6" md="4">
                <b-media>
                    <b-img center :src="barrera.visual.visual_img" height="130" width="130" fluid alt="Retrato de Cesar Cerezo mostrando una emoción"></b-img>
                    <div class="badge badge-secondary textoGrande">{{barrera.visual.visual_emocion}}</div>
                </b-media>
              </b-col>
              <!-- bocadillo mensaje -->
              <b-col>
              <div class="popover b-popover bs-popover-right bs-popover-right-docs"> 
                <div class="arrow" style="top:calc(50% - 4px)"></div>
                <h3 class="popover-header">Cesar Cerezo dice de la barrera...  </h3> 
                <div class="popover-body"> 
                  <p class="mb-0 textoGrande">{{barrera.visual.visual_comentario}}</p>
                </div> 
              </div>
              </b-col>
            </b-row>
            
            <div class="w-100 p-1 text-dark bg-ligth"></div> 

            <b-row>
                <b-col class="alert alert-info" role="alert"> 
                <h4 class="alert-heading"> 
                  <img src="../assets/img/iconoInfo.png" height="50" width="50"/> 
                  Como se puede arreglar esta barrera...</h4>
                <hr>
                <p class="mb-0 textoGrande">{{barrera.visual.visual_comentarioexplicado}}</p>
              </b-col>
            </b-row>
        </b-container>
        </span>


        <span v-else>
          <div class="txt">
            <b-container fluid>
            <!--<b-row class="mx-auto overflow-auto">-->
       
            <b-row>
              <b-col cols="6" md="4">
              <b-media>
                  <b-img  center :src="barrera.visual.visual_img" height="130" width="130" fluid alt="Retrato de Cesar Cerezo mostrando una emoción"></b-img>
                  <div class="badge badge-secondary textoGrande">{{barrera.visual.visual_emocion}}</div>
              </b-media>
             </b-col>

              <!-- bocadillo mensaje -->
              <b-col>
              <div class="popover b-popover bs-popover-right bs-popover-right-docs"> 
                <div class="arrow" style="top:calc(50% - 4px)"></div>
                <h3 class="popover-header">Cesar Cerezo dice de la barrera...  </h3> 
                <div class="popover-body"> 
                  <p class="mb-0 textoGrande">{{barrera.visual.visual_comentario}}</p>
                </div> 
              </div>
              </b-col>
            </b-row>
          </b-container>
          </div>
        </span>

          </div>
        </b-tab>


        <!-- ****************************************************************** -->
        <!-- ****************************************************************** -->
        <!-- ****************************************************************** -->

          <b-tab title="Blas Blanco" >
                <template #title>
                  <span class="icoVisual">Blas Blanco</span>
                </template>
          <div class="txt">
            <span v-if="barrera.bajavision.bajavision_comentario!='A mí no me afecta esta barrera'">
            <b-container fluid>
            <b-row>
              <div class="w-100 p-1 text-light colorRojoSuave textoGrande"> 
                  <img src="../assets/img/iconoAlerta.png" height="30" width="30"/> 
                  {{barrera.bajavision.bajavision_subtitulo}}
              </div>
            </b-row>
              <div class="w-100 p-1 text-dark bg-ligth"></div> 
              <b-row>
            <!-- <b-row class="mx-auto overflow-auto h-25"> -->
              <b-col cols="6" md="4">
                <b-media>
                    <b-img center :src="barrera.bajavision.bajavision_img" height="130" width="130" fluid alt="Retrato de Blas Blanco mostrando una emoción"></b-img>
                    <div class="badge badge-secondary textoGrande">{{barrera.bajavision.bajavision_emocion}}</div>
                </b-media>
              </b-col>
              <!-- bocadillo mensaje -->
              <b-col>
              <div class="popover b-popover bs-popover-right bs-popover-right-docs"> 
                <div class="arrow" style="top:calc(50% - 4px)"></div>
                <h3 class="popover-header">Blas Blanco dice de la barrera...  </h3> 
                <div class="popover-body"> 
                  <p class="mb-0 textoGrande">{{barrera.bajavision.bajavision_comentario}}</p>
                </div> 
              </div>
              </b-col>
            </b-row>
            
            <div class="w-100 p-1 text-dark bg-ligth"></div> 

            <b-row>
                <b-col class="alert alert-info" role="alert"> 
                <h4 class="alert-heading"> 
                  <img src="../assets/img/iconoInfo.png" height="50" width="50"/> 
                  Como se puede arreglar esta barrera...</h4>
                <hr>
                <p class="mb-0 textoGrande">{{barrera.bajavision.bajavision_comentarioexplicado}}</p>
              </b-col>
            </b-row>
        </b-container>
        </span>


        <span v-else>
          <div class="txt">
            <b-container fluid>
            <!--<b-row class="mx-auto overflow-auto">-->
       
            <b-row>
              <b-col cols="6" md="4">
              <b-media>
                  <b-img  center :src="barrera.bajavision.bajavision_img" height="130" width="130" fluid alt="Retrato de Blas Blanco mostrando una emoción"></b-img>
                  <div class="badge badge-secondary textoGrande">{{barrera.bajavision.bajavision_emocion}}</div>
              </b-media>
             </b-col>

              <!-- bocadillo mensaje -->
              <b-col>
              <div class="popover b-popover bs-popover-right bs-popover-right-docs"> 
                <div class="arrow" style="top:calc(50% - 4px)"></div>
                <h3 class="popover-header">Blas Blanco dice de la barrera...  </h3> 
                <div class="popover-body"> 
                  <p class="mb-0 textoGrande">{{barrera.bajavision.bajavision_comentario}}</p>
                </div> 
              </div>
              </b-col>
            </b-row>
          </b-container>
          </div>
        </span>

          </div>
        </b-tab>



        <!-- ****************************************************************** -->
        <!-- ****************************************************************** -->
        <!-- ****************************************************************** -->

      <b-tab title="Aurora Ausin" >
                <template #title>
                  <span class="icoAuditivo">Aurora Ausin</span>
                </template>
          <div class="txt">
            <span v-if="barrera.auditivo.auditivo_comentario!='A mí no me afecta esta barrera'">
            <b-container fluid>
            <b-row>
              <div class="w-100 p-1 text-light colorRojoSuave textoGrande"> 
                  <img src="../assets/img/iconoAlerta.png" height="30" width="30"/> 
                  {{barrera.auditivo.auditivo_subtitulo}}
              </div>
              </b-row>
              <div class="w-100 p-1 text-dark bg-ligth"></div> 
            <!--<b-row class="mx-auto overflow-auto"> -->
              <b-row>
              <b-col cols="6" md="4">                <b-media>
                    <b-img  center :src="barrera.auditivo.auditivo_img" height="130" width="130" fluid alt="Retrato de Aurora Ausin mostrando una emoción"></b-img>
                    <div class="badge badge-secondary textoGrande">{{barrera.auditivo.auditivo_emocion}}</div>
                </b-media>
              </b-col>

              <!-- bocadillo mensaje -->
              <b-col>
              <div class="popover b-popover bs-popover-right bs-popover-right-docs"> 
                <div class="arrow" style="top:calc(50% - 4px)"></div>
                <h3 class="popover-header">Aurora Ausin dice de la barrera...  </h3> 
                <div class="popover-body"> 
                  <p class="mb-0 textoGrande">{{barrera.auditivo.auditivo_comentario}}</p>
                </div> 
              </div>
              </b-col>
              </b-row>

            <div class="w-100 p-1 text-dark bg-ligth"></div> 
            <b-row>
                <b-col class="alert alert-info" role="alert"> 
                <h4 class="alert-heading"> 
                  <img src="../assets/img/iconoInfo.png" height="50" width="50"/> 
                  Como se puede arreglar esta barrera...</h4>
                <hr>
                <p class="mb-0 textoGrande">{{barrera.auditivo.auditivo_comentarioexplicado}}</p>
              </b-col>
            </b-row>
        </b-container>
        </span>



        <span v-else>
          <div class="txt">
            <b-container fluid>
            <!--<b-row class="mx-auto overflow-auto"> -->
              <b-row>
              <b-col cols="6" md="4">
            <b-media>
                <b-img  center :src="barrera.auditivo.auditivo_img" height="130" width="130" fluid alt="Retrato de Aurora Ausin mostrando una emoción"></b-img>
                <div class="badge badge-secondary textoGrande">{{barrera.auditivo.auditivo_emocion}}</div>
            </b-media>
             </b-col>

              <!-- bocadillo mensaje -->
              <b-col>
              <div class="popover b-popover bs-popover-right bs-popover-right-docs"> 
                <div class="arrow" style="top:calc(50% - 4px)"></div>
                <h3 class="popover-header">Aurora Ausin dice de la barrera...  </h3> 
                <div class="popover-body"> 
                  <p class="mb-0 textoGrande">{{barrera.auditivo.auditivo_comentario}}</p>
                </div> 
              </div>
              </b-col>

            </b-row>
          </b-container>
          </div>
        </span>

          </div>
        </b-tab>

        <!-- ****************************************************************** -->
        <!-- ****************************************************************** -->
        <!-- ****************************************************************** -->
      <b-tab title="Miguel Mota" >
                <template #title>
                  <span class="icoMotriz">Miguel Mota</span>
                </template>
          <div class="txt">
            <span v-if="barrera.motriz.motriz_comentario!='A mí no me afecta esta barrera'">
            <b-container fluid>
            <b-row>
              <div class="w-100 p-1 text-light colorRojoSuave textoGrande"> 
                  <img src="../assets/img/iconoAlerta.png" height="30" width="30"/> 
                  {{barrera.motriz.motriz_subtitulo}}
              </div>
              </b-row>
              <div class="w-100 p-1 text-dark bg-ligth"></div> 
            <!--<b-row class="mx-auto overflow-auto">-->
              <b-row>
              <b-col cols="6" md="4">                <b-media>
                    <b-img  center :src="barrera.motriz.motriz_img" height="130" width="130" fluid alt="Retrato de Miguel Mota mostrando una emoción"></b-img>
                    <div class="badge badge-secondary textoGrande">{{barrera.motriz.motriz_emocion}}</div>
                </b-media>
              </b-col>
              <!-- bocadillo mensaje -->
              <b-col>
              <div class="popover b-popover bs-popover-right bs-popover-right-docs"> 
                <div class="arrow" style="top:calc(50% - 4px)"></div>
                <h3 class="popover-header">Miguel Mota dice de la barrera...  </h3> 
                <div class="popover-body"> 
                  <p class="mb-0 textoGrande">{{barrera.motriz.motriz_comentario}}</p>
                </div> 
              </div>
              </b-col>
              </b-row>

            <div class="w-100 p-1 text-dark bg-ligth"></div> 
            <b-row>
                <b-col class="alert alert-info" role="alert"> 
                <h4 class="alert-heading"> 
                  <img src="../assets/img/iconoInfo.png" height="50" width="50"/> 
                  Como se puede arreglar esta barrera...</h4>
                <hr>
                <p class="mb-0 textoGrande">{{barrera.motriz.motriz_comentarioexplicado}}</p>
              </b-col>
            </b-row>
        </b-container>
        </span>


        <span v-else>
          <div class="txt">
            <b-container fluid>
            <!--<b-row class="mx-auto overflow-auto">-->
              <b-row>
              <b-col cols="6" md="4">

            <b-media>
                <b-img  center :src="barrera.motriz.motriz_img" height="130" width="130" fluid alt="Retrato de Miguel Mota mostrando una emoción"></b-img>
                <div class="badge badge-secondary textoGrande">{{barrera.motriz.motriz_emocion}}</div>
            </b-media>
             </b-col>
            
            <!-- bocadillo mensaje -->
              <b-col>
              <div class="popover b-popover bs-popover-right bs-popover-right-docs"> 
                <div class="arrow" style="top:calc(50% - 4px)"></div>
                <h3 class="popover-header">Miguel Mota dice de la barrera...  </h3> 
                <div class="popover-body"> 
                  <p class="mb-0 textoGrande">{{barrera.motriz.motriz_comentario}}</p>
                </div> 
              </div>
              </b-col>

            </b-row>
          </b-container>
          </div>
        </span>


          </div>
        </b-tab>


        <!-- ****************************************************************** -->
        <!-- ****************************************************************** -->
        <!-- ****************************************************************** -->



     <b-tab title="Oscar Coiba" >
                <template #title>
                  <span class="icoIntelectual">Oscar Coiba</span>
                </template>
          <div class="txt">
            <span v-if="barrera.intelectual.intelectual_comentario!='A mí no me afecta esta barrera'">
            <b-container fluid>
            <b-row>
              <div class="w-100 p-1 text-light colorRojoSuave textoGrande"> 
                  <img src="../assets/img/iconoAlerta.png" height="30" width="30"/> 
                  {{barrera.intelectual.intelectual_subtitulo}}
              </div>
              </b-row>
              <div class="w-100 p-1 text-dark bg-ligth"></div> 
            <!--<b-row class="mx-auto overflow-auto">-->
              <b-row>
              <b-col cols="6" md="4">                
                <b-media>
                    <b-img  center :src="barrera.intelectual.intelectual_img" height="130" width="130" fluid alt="Retrato de Oscar Coiba mostrando una emoción"></b-img>
                    <div class="badge badge-secondary textoGrande">{{barrera.intelectual.intelectual_emocion}}</div>
                </b-media>
              </b-col>
                
              <!-- bocadillo mensaje -->
              <b-col>
              <div class="popover b-popover bs-popover-right bs-popover-right-docs"> 
                <div class="arrow" style="top:calc(50% - 4px)"></div>
                <h3 class="popover-header">Oscab Coiba dice de la barrera...  </h3> 
                <div class="popover-body"> 
                  <p class="mb-0 textoGrande">{{barrera.intelectual.intelectual_comentario}}</p>
                </div> 
              </div>
              </b-col>
              </b-row>

            <div class="w-100 p-1 text-dark bg-ligth"></div> 
            <b-row>
                <b-col class="alert alert-info" role="alert"> 
                <h4 class="alert-heading"> 
                  <img src="../assets/img/iconoInfo.png" height="50" width="50"/> 
                  Como se puede arreglar esta barrera...</h4>
                <hr>
                <p class="mb-0 textoGrande">{{barrera.intelectual.intelectual_comentarioexplicado}}</p>
              </b-col>
            </b-row>
        </b-container>
        </span>

        <span v-else>
          <div class="txt">
            <b-container fluid>
            <!--<b-row class="mx-auto overflow-auto">-->
              <b-row>
              <b-col cols="6" md="4">
            <b-media>
                <b-img  center :src="barrera.intelectual.intelectual_img" height="130" width="130" fluid alt="Retrato de Oscar Coiba mostrando una emoción"></b-img>
                <div class="badge badge-secondary textoGrande">{{barrera.intelectual.intelectual_emocion}}</div>
            </b-media>
             </b-col>

                             
              <!-- bocadillo mensaje -->
              <b-col>
              <div class="popover b-popover bs-popover-right bs-popover-right-docs"> 
                <div class="arrow" style="top:calc(50% - 4px)"></div>
                <h3 class="popover-header">Oscab Coiba dice de la barrera...  </h3> 
                <div class="popover-body"> 
                  <p class="mb-0 textoGrande">{{barrera.intelectual.intelectual_comentario}}</p>
                </div> 
              </div>
              </b-col>


            </b-row>
          </b-container>
          </div>
        </span>

          </div>
        </b-tab>


 </b-tabs>
      <!-- ****************************************************************** -->

        <div class="txt">
          <hr>
          <b-container fluid class="p-4">
            <p></p>
            <b-button v-b-toggle.b1 size="lg" variant="primary">Consulta más información de la barrera de accesibilidad</b-button>
          </b-container>
          <b-collapse id ="b1">
            <hr>
            <h3>Descripción del problema</h3>
            {{barrera.descripcion_barrera}}
            <p></p>
            <h3>Sugerencias para resolver el problema</h3>
            {{barrera.sugerencia_resolver_barrera}}
            <p></p>
            <h3>Pautas WCAG 2.1 relacionadas</h3>
            <div v-for="barr in barrera.pautas_WCAG" :key="barr.titulo">
            <a :href="barr.enlace"  target="_blank" rel="noopener">{{barr.pautas_WCAG}}. {{barr.titulo}}</a> 
              - Nivel {{barr.nivel}} {{barr.principio}} 
            </div>
          </b-collapse>
      </div>
    </b-modal>
  </div>
</template>


<script>
//import json from '../assets/json/BarrerasAWeb_FinalCompleto.json';
//import datos from "../assets/json/postres.json";

import json from '../../public/BarrerasAWeb_FinalCompleto.json';
export default {
  props: {  
   identificador: {
      type: Number,
      default: 0 
   }
  },

  data(){
    return {
      barreras: json[this.identificador]["barreras"],
      barrera: json[this.identificador]["barreras"][0]
    }
  },
 
  methods: {
    showModal() {
      this.$refs['my-modal'].show()
    },
    hideModal() {
      this.$refs['my-modal'].hide()
    },
    toggleModal() {
     this.$refs['my-modal'].toggle('#toggle-btn')
    },
    selectBarrier(barrier){
      this.barrera=barrier
      console.log(this.barrera)
    }
  }
};
</script>


<style>
.bocadillomensaje {
  background-color:wheat;
  border-color: grey;
  text-align: center;
  /*background-image: url("../assets/img/mensajebocadillo.png"); */
}
.bocadilloinfo {
  background-color:aliceblue;

}

.icoBajaVision {
/*  width: 200px; 
    border: 2px solid red; 
*/
/*  background-image:url('https://encrypted-tbn3.gstatic.com/images?q=tbn:ANd9GcSj3XfIpf-OOJRCcWz4iN2CU3qMKVVbj0p0bRvKNGVo1U9pk_8ZIlyR8pWreA');
  background-size: 100%;
  border: 2px solid red; 

    /*width:100px;
    display:block;
    height:20px;
    background:rgb(80, 61, 61);
    color:white;
    text-decoration:none;
    padding-left:20px; */
}

.tituloModal{
  font-weight: bold;
  font-size:  larger;
  text-align:center;

}
.colorAmarillo {
  background-color: bisque;
}
.colorRojoSuave {
  background-color: rgb(235, 81, 81);
}

.textoGrande {
  font-size: 1.2em;

}
.textoXGrande {
  font-size: x-large;
}

.textoIzquierda {
  text-align: left;
  border: 1px solid grey;
}

.icoVisual:before{
    content: '';
    background:url("../assets/iconosDisc/visual.svg");
    background-size:cover;
    position:absolute;
    width:20px;
    height:20px;
    margin-left:-20px;
}
.icoBajaVision:before{
    width: 200px; 
     content: '';
    /*background:url('https://encrypted-tbn3.gstatic.com/images?q=tbn:ANd9GcSj3XfIpf-OOJRCcWz4iN2CU3qMKVVbj0p0bRvKNGVo1U9pk_8ZIlyR8pWreA');*/
    background:url("../assets/iconosDisc/baja_vision.svg");
    background-size:cover;
    position:absolute;
    width:20px;
    height:20px;
    margin-left:-20px;
}


.icoAuditivo:before{
    content: '';
    background:url("../assets/iconosDisc/auditivo.svg");
    background-size:cover;
    position:absolute;
    width:20px;
    height:20px;
    margin-left:-20px;
}

.icoMotriz:before{
    content: '';
    background:url("../assets/iconosDisc/motriz.svg");
    background-size:cover;
    position:absolute;
    width:20px;
    height:20px;
    margin-left:-20px;
}
.icoIntelectual:before{
    content: '';
    background:url("../assets/iconosDisc/intelectual.svg");
    background-size:cover;
    position:absolute;
    width:20px;
    height:20px;
    margin-left:-20px;
}
.textoCentrado {
  border: 1px solid red;
    text-align: center;

/*
  display: flex;
  align-items: center;
  justify-content: center;
  */
  /*min-height: 100vh;*/
  }

 /* ****** */
.bd-example-popover-static .popover {
    position: relative;
    display: block;
    float: left;
    width: 260px;
    margin: 1.25rem;
}
.popover.b-popover {
    display: block;
    opacity: 1;
    outline: 0;
}
.bs-popover-auto[x-placement^=right], .bs-popover-right {
    margin-left: 0.5rem;
}
.popover, .popover .arrow {
    position: absolute;
    display: block;
}
.popover {
    top: 0;
    left: 0;
    z-index: 1060;
    max-width: 566px;
    font-family: -apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,Liberation Sans,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color Emoji;
    font-style: normal;
    font-weight: 400;
    line-height: 1.5;
    text-align: left;
    text-align: start;
    text-decoration: none;
    text-shadow: none;
    text-transform: none;
    letter-spacing: normal;
    word-break: normal;
    word-spacing: normal;
    white-space: normal;
    line-break: auto;
    font-size: 1.5rem;
    word-wrap: break-word;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid rgba(0,0,0,.2);
    border-radius: 0.3rem;
}
*, :after, :before {
    box-sizing: border-box;
}


/* ***** */

.bocadillo{
 border-radius: 30px;
 background-color: #808080;
 color: #fff;
 padding: 30px;
 width: 300px;
 font-family: 'Trebuchet ms';
 font-size: 1em
}
.bocadillo:before {
 content:"";
 position: absolute;
 width: 0;
 height: 0;
 border-top: 20px solid #808080;
 border-left: 18px solid transparent;
 margin: 68px 0 0 250px;
}

.tab {
background-color: rgb(246, 167, 8) !important;
color:black !important;
}

</style>
